// panel-wrapper.component.ts
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-card-wrapper',
  template: `
    <mat-card appearance="outlined" class="mat-elevation-z5 show-box-shadow">
      {{ to.visible }}
      <ng-container #fieldComponent></ng-container>
    </mat-card>
  `,
  standalone: false,
})
export class FormlyCardWrapperComponent extends FieldWrapper {}
